import { FieldStateV3, FormContext, FormStateV3 } from '../../../../commonv3/states/form/FormStateV3';
import {
    DependencyValidators,
    EmailValidators,
    NumberValidators,
    StringValidators,
} from '../../../../commonv3/states/form/validators';
import { SecureUser, UserId } from '../../../../mainv2/types/user';

export type EditableUser = {
    id?: UserId;
    has_password: boolean;
    name: string;
    furigana: string;
    age: number;
    email: string;
    password: string;
    password_confirmation: string;
};

export type UserFormSchema = {
    // Only set for existing users
    id: FieldStateV3<UserId>;
    // Only set for existing users with password
    has_password: FieldStateV3<boolean>;
    name: FieldStateV3<string>;
    furigana: FieldStateV3<string>;
    age: FieldStateV3<number>;
    email: FieldStateV3<string>;
    password: FieldStateV3<string>;
    password_confirmation: FieldStateV3<string>;
};

export class UserFormState extends FormStateV3<EditableUser, UserFormSchema> {
    constructor() {
        const passwordState = new FieldStateV3<string>([StringValidators.required()]);
        super({
            id: new FieldStateV3<UserId>(),
            has_password: new FieldStateV3<boolean>(),
            name: new FieldStateV3<string>([StringValidators.required()]),
            furigana: new FieldStateV3<string>([StringValidators.required()]),
            age: new FieldStateV3<number>([NumberValidators.required()]),
            email: new FieldStateV3<string>([EmailValidators.combined()]),
            password: passwordState,
            password_confirmation: new FieldStateV3<string>([
                StringValidators.required(),
                DependencyValidators.equalWith(passwordState, 'パスワードが一致しませんでした'),
            ]),
        });
    }
    init(user?: SecureUser) {
        const defaultUserParams = {
            id: null,
            has_password: false,
            name: '',
            email: '',
            furigana: '',
            age: null,
            password: '',
            password_confirmation: '',
        };
        this._init('user', new FormContext(), { ...defaultUserParams, ...(user ? user : {}) });
        this.updatePasswordValidators(this);
    }
    updatePasswordValidators(userFormState: UserFormState) {
        if (userFormState.fields.has_password.originalValue == true) {
            userFormState.fields.password.validators = [];
            userFormState.fields.password_confirmation.validators = [];
        }
    }
}
